import { useParams } from 'next/navigation';
import { useSelector } from 'react-redux';

import { appRoutes } from '@/appRoutes';

import type { RootState } from '@/store';

type CallWithSlug<T> = {
  [K in keyof T]: T[K] extends (slug: string) => infer R ? R : T[K];
};

export const useWorkspaceRoutes = () => {
  const params = useParams<{ workspace_slug?: string | string[] }>();
  const persistedWorkspaceSlug = useSelector(
    (state: RootState) => state.workspaces.currentWorkspace?.slug,
  );
  const routeWorkspaceSlug = Array.isArray(params?.workspace_slug)
    ? params.workspace_slug[0]
    : params?.workspace_slug;
  const workspaceSlug = routeWorkspaceSlug ?? persistedWorkspaceSlug;

  if (!workspaceSlug) throw new Error('Workspace slug is not set');

  const workspace = appRoutes.workspace;

  const mapped = {} as CallWithSlug<typeof workspace>;

  for (const key in workspace) {
    const value = workspace[key as keyof typeof workspace];
    (mapped as any)[key] =
      typeof value === 'function' ? value(workspaceSlug) : value;
  }

  return mapped;
};
